module.exports = function getResource(label) {
    const resources = {
        signInText: 'Ouvrir une session',
        joinNowText: 'Join Now'
    };

    return resources[label];
};
